import { DropDownFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { BlockVariant } from "@store/Components/Common/Block/variant/config";

export const blockVariantFieldOptions = [
    {
        displayName: "Alternative",
        value: BlockVariant.Alternative,
    },
    {
        displayName: "Bordered",
        value: BlockVariant.Bordered,
    },
    {
        displayName: "Separated",
        value: BlockVariant.Separated,
    },
];

const blockVariantField = {
    displayName: "Variant",
    editorTemplate: "DropDownField",
    options: blockVariantFieldOptions,
    defaultValue: BlockVariant.None,
    fieldType: "General",
} as DropDownFieldDefinition<string>;

export default blockVariantField;
